export default __webpack_public_path__ + "static/media/delivery.0799010c.svg";